module.exports = __webpack_public_path__ + "img/plus.deb5112d.svg";